// This file is auto-generated by @hey-api/openapi-ts

import type { DeleteApiCommentsByIdUnlikeResponse, DeleteApiPositionedBannersByIdResponse, DeleteApiPostsByIdUnlikeResponse, GetApiClubsByIdFeedResponse, GetApiClubsByIdResponse, GetApiDrawsByIdResponse, GetApiPositionedBannersByIdByIdResponse, GetApiPositionedBannersResponse, GetApiUsersByIdPostsResponse, GetApiUsersByIdPreviewResponse, GetApiUsersFeedMatchesResponse, GetApiUsersFeedNewsResponse, GetApiUsersFeedOffersResponse, GetApiUsersFeedPostsResponse, GetApiUsersFeedResponse, GetApiUsersFollowersListByIdResponse, GetApiUsersUserMatchesResponse, PostApiCommentsByIdLikeResponse, PostApiPositionedBannersResponse, PostApiPostsByIdLikeResponse, PostApiPostsResponse, PostApiSessionsBackofficeResponse, PostApiSessionsFacebookResponse, PostApiSessionsResponse, PostApiUsersMarketResponse, PostApiUsersSignUpAdditionalInfoResponse, PostApiUsersSignUpResponse, PutApiDrawsByIdChangeBestLoserRankingResponse, PutApiDrawsByIdChangeWinnerResponse, PutApiDrawsByIdDeleteMatchesResponse, PutApiEditProfileGeneralInfoResponse, PutApiPositionedBannersByIdResponse } from './types.gen';

export const postApiSessionsFacebookResponseTransformer = async (data: any): Promise<PostApiSessionsFacebookResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
        if (data.user.token_expiration) {
            data.user.token_expiration = new Date(data.user.token_expiration);
        }
        if (data.user.premium_expiration) {
            data.user.premium_expiration = new Date(data.user.premium_expiration);
        }
    }
    return data;
};

export const postApiSessionsBackofficeResponseTransformer = async (data: any): Promise<PostApiSessionsBackofficeResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
        if (data.user.token_expiration) {
            data.user.token_expiration = new Date(data.user.token_expiration);
        }
        if (data.user.premium_expiration) {
            data.user.premium_expiration = new Date(data.user.premium_expiration);
        }
    }
    return data;
};

export const getApiClubsByIdResponseTransformer = async (data: any): Promise<GetApiClubsByIdResponse> => {
    if (data.members) {
        data.members = data.members.map((item: any) => {
            return fitPlayerProfileSchemaResponseTransformer(item);
        });
    }
    if (data.teachers) {
        data.teachers = data.teachers.map((item: any) => {
            return fitPlayerProfileSchemaResponseTransformer(item);
        });
    }
    if (data.competitions) {
        data.competitions = data.competitions.map((item: any) => {
            return competitionSchemaResponseTransformer(item);
        });
    }
    if (data.feed) {
        data.feed = data.feed.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    if (data.draws) {
        data.draws = data.draws.map((item: any) => {
            return drawSchemaResponseTransformer(item);
        });
    }
    return data;
};

const fitPlayerProfileSchemaResponseTransformer = (data: any) => {
    if (data.birth_date) {
        data.birth_date = new Date(data.birth_date);
    }
    if (data.certificate_expiration) {
        data.certificate_expiration = new Date(data.certificate_expiration);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const competitionSchemaResponseTransformer = (data: any) => {
    data.from = new Date(data.from);
    data.to = new Date(data.to);
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const postSchemaResponseTransformer = (data: any) => {
    data.comments = data.comments.map((item: any) => {
        return commentSchemaResponseTransformer(item);
    });
    return data;
};

const commentSchemaResponseTransformer = (data: any) => {
    if (data.children) {
        data.children = data.children.map((item: any) => {
            return commentSchemaResponseTransformer(item);
        });
    }
    return data;
};

const drawSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.match_date) {
        data.match_date = new Date(data.match_date);
    }
    return data;
};

export const getApiClubsByIdFeedResponseTransformer = async (data: any): Promise<GetApiClubsByIdFeedResponse> => {
    if (data.feed) {
        data.feed = data.feed.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const postApiCommentsByIdLikeResponseTransformer = async (data: any): Promise<PostApiCommentsByIdLikeResponse> => {
    data.comment = commentSchemaResponseTransformer(data.comment);
    return data;
};

export const deleteApiCommentsByIdUnlikeResponseTransformer = async (data: any): Promise<DeleteApiCommentsByIdUnlikeResponse> => {
    if (data.comment) {
        data.comment = commentSchemaResponseTransformer(data.comment);
    }
    return data;
};

export const getApiDrawsByIdResponseTransformer = async (data: any): Promise<GetApiDrawsByIdResponse> => {
    data = drawResponseSchemaResponseTransformer(data);
    return data;
};

const drawResponseSchemaResponseTransformer = (data: any) => {
    data.matches = data.matches.map((item: any) => {
        if (item.draw) {
            item.draw = drawSummarySchemaResponseTransformer(item.draw);
        }
        return item;
    });
    return data;
};

const drawSummarySchemaResponseTransformer = (data: any) => {
    if (data.match_date) {
        data.match_date = new Date(data.match_date);
    }
    return data;
};

export const putApiDrawsByIdDeleteMatchesResponseTransformer = async (data: any): Promise<PutApiDrawsByIdDeleteMatchesResponse> => {
    if (data.draw) {
        data.draw = drawResponseSchemaResponseTransformer(data.draw);
    }
    return data;
};

export const putApiDrawsByIdChangeWinnerResponseTransformer = async (data: any): Promise<PutApiDrawsByIdChangeWinnerResponse> => {
    if (data.draw) {
        data.draw = drawResponseSchemaResponseTransformer(data.draw);
    }
    return data;
};

export const putApiDrawsByIdChangeBestLoserRankingResponseTransformer = async (data: any): Promise<PutApiDrawsByIdChangeBestLoserRankingResponse> => {
    if (data.draw) {
        data.draw = drawResponseSchemaResponseTransformer(data.draw);
    }
    return data;
};

export const putApiEditProfileGeneralInfoResponseTransformer = async (data: any): Promise<PutApiEditProfileGeneralInfoResponse> => {
    if (data.birth_date) {
        data.birth_date = new Date(data.birth_date);
    }
    return data;
};

export const postApiPostsByIdLikeResponseTransformer = async (data: any): Promise<PostApiPostsByIdLikeResponse> => {
    if (data.post) {
        data.post = postSchemaResponseTransformer(data.post);
    }
    return data;
};

export const deleteApiPostsByIdUnlikeResponseTransformer = async (data: any): Promise<DeleteApiPostsByIdUnlikeResponse> => {
    if (data.post) {
        data.post = postSchemaResponseTransformer(data.post);
    }
    return data;
};

export const postApiPostsResponseTransformer = async (data: any): Promise<PostApiPostsResponse> => {
    if (data.post) {
        data.post = postSchemaResponseTransformer(data.post);
    }
    return data;
};

export const postApiUsersSignUpResponseTransformer = async (data: any): Promise<PostApiUsersSignUpResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
    }
    return data;
};

export const postApiUsersSignUpAdditionalInfoResponseTransformer = async (data: any): Promise<PostApiUsersSignUpAdditionalInfoResponse> => {
    if (data.user.birth_date) {
        data.user.birth_date = new Date(data.user.birth_date);
    }
    return data;
};

export const postApiSessionsResponseTransformer = async (data: any): Promise<PostApiSessionsResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
        if (data.user.token_expiration) {
            data.user.token_expiration = new Date(data.user.token_expiration);
        }
        if (data.user.premium_expiration) {
            data.user.premium_expiration = new Date(data.user.premium_expiration);
        }
    }
    return data;
};

export const getApiUsersByIdPostsResponseTransformer = async (data: any): Promise<GetApiUsersByIdPostsResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getApiUsersByIdPreviewResponseTransformer = async (data: any): Promise<GetApiUsersByIdPreviewResponse> => {
    if (data.user) {
        data.user = userSchemaResponseTransformer(data.user);
    }
    return data;
};

const userSchemaResponseTransformer = (data: any) => {
    if (data.birth_date) {
        data.birth_date = new Date(data.birth_date);
    }
    if (data.banned_at) {
        data.banned_at = new Date(data.banned_at);
    }
    if (data.confirmed_at) {
        data.confirmed_at = new Date(data.confirmed_at);
    }
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data.updated_at) {
        data.updated_at = new Date(data.updated_at);
    }
    if (data.notifications_last_seen) {
        data.notifications_last_seen = new Date(data.notifications_last_seen);
    }
    if (data.first_sign_in_at) {
        data.first_sign_in_at = new Date(data.first_sign_in_at);
    }
    return data;
};

export const getApiUsersFollowersListByIdResponseTransformer = async (data: any): Promise<GetApiUsersFollowersListByIdResponse> => {
    if (data.followers) {
        data.followers = data.followers.map((item: any) => {
            return userSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getApiUsersFeedResponseTransformer = async (data: any): Promise<GetApiUsersFeedResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getApiUsersFeedPostsResponseTransformer = async (data: any): Promise<GetApiUsersFeedPostsResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getApiUsersFeedMatchesResponseTransformer = async (data: any): Promise<GetApiUsersFeedMatchesResponse> => {
    if (data.matches) {
        data.matches = data.matches.map((item: any) => {
            return matchSchemaResponseTransformer(item);
        });
    }
    return data;
};

const matchSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const getApiUsersFeedOffersResponseTransformer = async (data: any): Promise<GetApiUsersFeedOffersResponse> => {
    if (data.offers) {
        data.offers = data.offers.map((item: any) => {
            return offerSchemaResponseTransformer(item);
        });
    }
    return data;
};

const offerSchemaResponseTransformer = (data: any) => {
    if (data.sale_end) {
        data.sale_end = new Date(data.sale_end);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const getApiUsersFeedNewsResponseTransformer = async (data: any): Promise<GetApiUsersFeedNewsResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const postApiUsersMarketResponseTransformer = async (data: any): Promise<PostApiUsersMarketResponse> => {
    if (data.offers) {
        data.offers = data.offers.map((item: any) => {
            return offerSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getApiUsersUserMatchesResponseTransformer = async (data: any): Promise<GetApiUsersUserMatchesResponse> => {
    if (data.user_matches) {
        data.user_matches = data.user_matches.map((item: any) => {
            return userMatchSchemaResponseTransformer(item);
        });
    }
    return data;
};

const userMatchSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    if (data.confirmed_at) {
        data.confirmed_at = new Date(data.confirmed_at);
    }
    if (data.rejected_at) {
        data.rejected_at = new Date(data.rejected_at);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const getApiPositionedBannersResponseTransformer = async (data: any): Promise<GetApiPositionedBannersResponse> => {
    if (data.data) {
        data.data = data.data.map((item: any) => {
            return positionedBannerResponseSchemaResponseTransformer(item);
        });
    }
    return data;
};

const positionedBannerResponseSchemaResponseTransformer = (data: any) => {
    if (data.custom_banners) {
        data.custom_banners = data.custom_banners.map((item: any) => {
            return customBannerSchemaResponseTransformer(item);
        });
    }
    return data;
};

const customBannerSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data.updated_at) {
        data.updated_at = new Date(data.updated_at);
    }
    return data;
};

export const postApiPositionedBannersResponseTransformer = async (data: any): Promise<PostApiPositionedBannersResponse> => {
    data.positioned_banner = positionedBannerResponseSchemaResponseTransformer(data.positioned_banner);
    return data;
};

export const getApiPositionedBannersByIdByIdResponseTransformer = async (data: any): Promise<GetApiPositionedBannersByIdByIdResponse> => {
    data = positionedBannerResponseSchemaResponseTransformer(data);
    return data;
};

export const deleteApiPositionedBannersByIdResponseTransformer = async (data: any): Promise<DeleteApiPositionedBannersByIdResponse> => {
    data.positioned_banner = positionedBannerResponseSchemaResponseTransformer(data.positioned_banner);
    return data;
};

export const putApiPositionedBannersByIdResponseTransformer = async (data: any): Promise<PutApiPositionedBannersByIdResponse> => {
    data.positioned_banner = positionedBannerResponseSchemaResponseTransformer(data.positioned_banner);
    return data;
};
